import type { GetAvailableCountriesQuery } from 'services/shopify';

const PREFERRED_ORDER = ['US', 'CA', 'CH', 'GB', 'DE'];

export const sortCountriesByPreferredOrder = ({
  countries,
}: {
  countries: GetAvailableCountriesQuery['localization']['availableCountries'];
}) =>
  countries.sort(
    (a, b) =>
      PREFERRED_ORDER.indexOf(a.isoCode) - PREFERRED_ORDER.indexOf(b.isoCode),
  );
